import React, { useLayoutEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const ACTIVE_USER_KEY = 'mercadobulk_active_app_user_id';

const exactKeysToClear = [
  // Historial / sesión de carga
  'bulk_upload_history',
  'bulk_upload_current_session',

  // Estado de cuenta
  'mlb_calendar_notes',
  'theme',
  'ml_store_name',
  'ml_prohibited_words',
  'ml_translation_mode',

  // Mercado Libre - datos del vendedor conectado
  'ml_connection',
  'mercadolibre_access_token',
  'mercadolibre_refresh_token',
  'mercadolibre_user_id',
  'mercadolibre_token_expires_at',
  'mercadolibre_last_sync',
  'mercadolibre_last_validation',

  // OAuth temporal
  'ml_oauth_code_verifier',
  'ml_oauth_result'
];

const clearPreviousAccountCache = () => {
  if (typeof window === 'undefined') return;

  exactKeysToClear.forEach((key) => {
    try {
      window.localStorage.removeItem(key);
    } catch {}
  });

  // Limpiar autosaves de cargas del usuario anterior
  try {
    const keys = [];

    for (
      let i = 0;
      i < window.localStorage.length;
      i += 1
    ) {
      const key = window.localStorage.key(i);

      if (
        key &&
        key.startsWith('bulk_upload_autosave_')
      ) {
        keys.push(key);
      }
    }

    keys.forEach((key) => {
      window.localStorage.removeItem(key);
    });
  } catch {}

  // Limpiar la sesión COMPLETA en IndexedDB.
  // Esto evita que otro usuario recupere una carga
  // que estaba a medio hacer en esta misma máquina.
  try {
    if (window.indexedDB) {
      window.indexedDB.deleteDatabase(
        'mercadobulk_bulk_upload'
      );
    }
  } catch {}
};

const AccountBrowserIsolation = () => {
  const { user } = useAuth();

  useLayoutEffect(() => {
    if (!user?.id) {
      return;
    }

    let previousUserId = null;

    try {
      previousUserId =
        window.localStorage.getItem(
          ACTIVE_USER_KEY
        );
    } catch {}

    /*
     * Primera ejecución del sistema:
     * NO borrar nada.
     *
     * Así conservamos los datos existentes
     * de la cuenta que ya estaba funcionando.
     */
    if (!previousUserId) {
      try {
        window.localStorage.setItem(
          ACTIVE_USER_KEY,
          user.id
        );
      } catch {}

      console.log(
        '👤 Navegador asociado inicialmente a esta cuenta.'
      );

      return;
    }

    /*
     * Solo limpiar cuando realmente cambió
     * la cuenta autenticada.
     */
    if (
      String(previousUserId) !==
      String(user.id)
    ) {
      console.log(
        '🔐 Cambio de usuario detectado. Limpiando caché de la cuenta anterior.'
      );

      clearPreviousAccountCache();

      try {
        window.localStorage.setItem(
          ACTIVE_USER_KEY,
          user.id
        );
      } catch {}

      window.dispatchEvent(
        new CustomEvent(
          'mercadobulk-account-changed',
          {
            detail: {
              previousUserId,
              currentUserId: user.id
            }
          }
        )
      );
    }
  }, [user?.id]);

  return null;
};

export default AccountBrowserIsolation;
